var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal",
      class: { "show-modal": _vm.value },
      attrs: { id: _vm.idModal, role: "dialog", tabindex: "-1" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          class: {
            "modal-dialog-custom": !_vm.isCentered && !_vm.isTop,
            "modal-dialog-centered": _vm.isCentered
          },
          attrs: { role: "document" }
        },
        [
          _c(
            "div",
            { staticClass: "modal-content", style: { width: _vm.width } },
            [
              _c(
                "div",
                { staticClass: "modal-header shadow align-items-center" },
                [
                  _c("div", { staticClass: "modal-title" }, [
                    _c("div", { staticClass: "border-icon" }, [
                      _c("i", {
                        staticClass: "text-orange",
                        class: ["fa", _vm.icon]
                      })
                    ]),
                    _vm._v(" " + _vm._s(_vm.title) + " ")
                  ]),
                  _vm.showTopClose
                    ? _c(
                        "span",
                        {
                          staticClass: "close-border p-1 mr-2 mt-0",
                          on: { click: _vm.cancel }
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-window-close close-ico"
                          }),
                          _vm._v(" " + _vm._s(_vm.cancelText) + " ")
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _c("div", { staticClass: "modal-body" }, [_vm._t("default")], 2),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _vm.showCancel && !_vm.showTopClose
                    ? _c(
                        "action-button",
                        {
                          attrs: {
                            i: "fas fa-times-circle",
                            variant: "outline-danger"
                          },
                          on: { click: _vm.cancel }
                        },
                        [_vm._v(" " + _vm._s(_vm.cancelText) + " ")]
                      )
                    : _vm._e(),
                  _vm.showSave
                    ? _c(
                        "action-button",
                        {
                          staticClass: "px-4",
                          attrs: { variant: "success" },
                          on: { click: _vm.save }
                        },
                        [_vm._v(" " + _vm._s(_vm.saveText) + " ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }